export const BEFORE_YOU_BUY_QUESTIONS = [
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.otherBooks.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.otherBooks.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.medication.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.medication.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.arabic.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.arabic.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.ingredients.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.ingredients.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.children.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.children.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.pregnancy.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.pregnancy.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.results.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.results.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.delivery.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.delivery.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.cancel.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.cancel.answer',
  },
  {
    questionKey: 'onboarding.landingWellness.beforeYouBuy.whatNext.question',
    answerKey: 'onboarding.landingWellness.beforeYouBuy.whatNext.answer',
  },
] as const
